import 'jquery';

export class NotificationDropdown {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.translations = o.translations;
        this.endpoints = o.endpoints;

        this.json = [];
        this.objects = [];
    }

    _setJson(json) {
        this.json = json;
    }

    _addObject(o) {
        this.objects.push(o);
    }

    _addObjectsFromJson() {
        if (typeof this.json === "undefined" || this.json === null) {
            return;
        }

        for (var i = 0, nr = this.json.length; i < nr; i++) {
            var object = this.json[i];
            this._addObject(object);
        }
    }

    _render(domElement) {
        var nrNotifications = this.objects.length;

        let wrapper = document.createElement('div');
        $(wrapper).addClass('notifications-wrapper dropdown-menu dropdown-menu-right unify-dropdown-notification');
        /*
         <div class='notification-wrapper dropdown-menu dropdown-menu-right unify-dropdown-notification'>
            <div class='notifications-header'>
                <h4>Notifications</h4>
            </div>
            <ul>...</ul>
        </div>
         */
        let header = document.createElement('div');
        $(header).addClass('notifications-header');

        let h4 = document.createElement('h4')
        if(nrNotifications === 0){
            h4.innerHTML = `${this.translations.internal.NotificationsHeading}`;
        }
        else {
            h4.innerHTML = `${this.translations.internal.NotificationsHeading} (${this.objects.length})`;
        }
        
        // <div class="no-notifications-message">YOU HAVE NO NOTIFICATIONS</div>
        let noNotifications = document.createElement('div');
        noNotifications.setAttribute('class', 'no-notifications-message')
        noNotifications.innerHTML = this.translations.internal.NotificationsNoNotifications;
        
        // <ul>...</ul>
        let ul = document.createElement('ul')
        ul.setAttribute('aria-labelledby', "notification-drop")

        for (var i = 0, nr = this.objects.length; i < nr; i++) {
            var object = this.objects[i];
            this._createLi(ul, object);
        }

        header.appendChild(h4)
        wrapper.appendChild(header)
        if(nrNotifications === 0){
            wrapper.appendChild(noNotifications)
        }
        else {
            wrapper.appendChild(ul)
        }
        domElement.appendChild(wrapper)
    }


    _isToday(someDate) {
        let today = new Date()
        return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
    }

    _isYesterday(someDate) {
        let today = new Date()
        return someDate.getDate() + 1 === today.getDate() &&
          someDate.getMonth() === today.getMonth() &&
          someDate.getFullYear() === today.getFullYear()
      }

    _getDate(date) {
        let options = {}
        if(this._isToday(date)){
            return this.translations.internal.Today.toLowerCase()
        }
        if(this._isYesterday(date)){
            return this.translations.internal.Yesterday.toLowerCase()
        }

        options = {};
        return date.toLocaleDateString(unify.currentCulture, options)
    }

    _createLi(domElement, object) {
        var that = this;
        let culture = unify.currentCulture;
        let descriptionString = object && object.description ? object.description[culture] || description[Cultures.ENGLISH] : '';
        let linkTextString = object && object.linkText ? object.linkText[culture] || linkText[Cultures.ENGLISH]: '';
        let titleString = object && object.title ? object.title[culture] || title[Cultures.ENGLISH] : '';
        
        let li = document.createElement('li')
        let formatedDate = this._getDate(new Date(object.date))
        // <li>
        //     <div>
        //         <div class="action-bar">
        //             <div class="action"></div>
        //         </div>
        //         <div class="header">
        //             <div class="title">
        //                 <h5>${object.title}</h5>
        //             </div>
        //             <div class="date">DATE</div>
        //         </div>
        //         <div class="description">${object.description}</div>
        //         <div class="link">
        //             <a href="${object.linkUrl}">
        //                 <span>${object.linkText}</span>
        //             </a>
        //             OR
        //             <div>${object.linkText}</div>
        //         </div>
        //     </div>
        // </li>

        let div = document.createElement('div')
        $(div).on("click", function (e) { that._handleOnLinkClick(this, e, object.linkUrl); });
        let actionBar = document.createElement('div')
        actionBar.setAttribute('class', 'action-bar')
        let action = document.createElement('div')
        action.setAttribute('class', 'action')
        if(object.canBeDismissed === true){
            let close = document.createElement('i')
            close.setAttribute('class', 'sp sp-close')
            $(close).on("click", function (e) { that._handleDismissClick(this, e, object.id); });
            action.appendChild(close)
        }

        let header = document.createElement('div')
        header.setAttribute('class', 'header')
        let title = document.createElement('div')
        title.setAttribute('class', 'title')
        let h5 = document.createElement('h5')
        h5.innerHTML = titleString.toLowerCase()
        let date = document.createElement('div')
        date.setAttribute('class', 'date')
        date.innerHTML = formatedDate
        let description = document.createElement('div')
        description.setAttribute('class', 'description')
        description.innerHTML = descriptionString
        let link = document.createElement('div')
        link.setAttribute('class', 'link')
        
        // itemLink:
        if (typeof object.linkUrl === 'undefined' || object.linkUrl === null) {
            // linkText
            if (typeof object.linkText !== 'undefined') {
                link.innerHTML = linkTextString;
            }
        }
        else {
            // <a href='object.linkUrl'><span>object.linkText</span></a>
            let a = document.createElement('a')
            a.setAttribute('href', object.linkUrl)
            $(a).on("click", function (e) { that._handleOnLinkClick(this, e, object.linkUrl); });

            let span = document.createElement('span')
            span.innerHTML = linkTextString

            a.appendChild(span)

            link.appendChild(a)
        }
        
        actionBar.appendChild(action)

        title.appendChild(h5)
        header.appendChild(title)
        header.appendChild(date)

        div.appendChild(actionBar)
        div.appendChild(header)
        div.appendChild(description)
        div.appendChild(link)

        li.appendChild(div)
        
        domElement.appendChild(li)
    }

    _fetchNotifications() {
        let that = this;
        new Promise(function (resolve, reject) {
            let url = `${that.endpoints.NotificationUri}/get`;
            $.ajax({
                context: that,
                method: 'POST',
                url: url,
            })
            .then(function (response) {
                that.setNotifications(response.notifications)
                // show the notification drop
                $('.unify-header-notification-drop').removeClass('unify-hidden');
            })
            .catch(function (response) {
                console.log('notificationdropdown.js -> _fetchNotifications, Error in ajax request, response:', response);
                that.setNotifications([]);
                // hide the notification drop
                $('.unify-header-notification-drop').addClass('unify-hidden');
            })
        });
    }

    /**
     * Unify.showNotificationDropdown();
     * Set the notifications shown in the notifications dropdown.
     * @example Unify.setNotifications([
        {title:'Pending signature', date: '10/20/2020', description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac nunc feugiat, ultrices nunc in, molestie lectus. Sed nec augue eu justo pretium fringilla ac nec neque. Pellentesque mollis risus eu mattis faucibus. Maecenas ornare, elit in tincidunt laoreet, nibh elit laoreet erat, id vestibulum ex ante interdum lacus. Ut commodo finibus metus, id varius tortor iaculis a. Aliquam at neque sed enim interdum pretium ac in magna. Donec quam sapien, congue vitae erat vel, scelerisque scelerisque tellus. Donec fringilla nunc consequat gravida pharetra. Aliquam luctus erat in nisi ultrices, vel pulvinar massa maximus. Morbi velit ex, commodo in nunc eu, lobortis dignissim orci. Suspendisse porta maximus mi, at dapibus nisl egestas eu. Mauris convallis euismod ultrices. Suspendisse potenti.', linkText:'Sign document', linkUrl:'http://google.com'},
        {title:'Pending signature', date: '08/20/2020', description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac nunc feugiat, ultrices nunc in, molestie lectus. Sed nec augue eu justo pretium fringilla ac nec neque. Pellentesque mollis risus eu mattis faucibus. Maecenas ornare, elit in tincidunt laoreet, nibh elit laoreet erat, id vestibulum ex ante interdum lacus. Ut commodo finibus metus, id varius tortor iaculis a. Aliquam at neque sed enim interdum pretium ac in magna. Donec quam sapien, congue vitae erat vel, scelerisque scelerisque tellus. Donec fringilla nunc consequat gravida pharetra. Aliquam luctus erat in nisi ultrices, vel pulvinar massa maximus. Morbi velit ex, commodo in nunc eu, lobortis dignissim orci. Suspendisse porta maximus mi, at dapibus nisl egestas eu. Mauris convallis euismod ultrices. Suspendisse potenti.', linkText:'Sign fund change', linkUrl:'https://yahoo.com'},
        ])
     * @param json Notifications for the user.
     * @param json.title The title.
     * @param json.description The description.
     * @param json.linkText The link text.
     * @param json.linkUrl The url.
     */
    setNotifications(json) {
        // clear objects..
        this.objects = []
        this._setJson(json);
        this._addObjectsFromJson();
        this._updateTopBarWithNrNotifications();
        this._addNotificationsDropdown();
    }

    _addNotificationsDropdown() {
        // remove old
        $('#unify-notificationmenu-header .notifications-wrapper').remove();
        
        var dropdownDiv = $('#unify-notificationmenu-header')[0];
        // add new
        this._render(dropdownDiv)
    }

    _showDropdown() {
        $('.unify-header-notification-drop').removeClass('unify-hidden')
    }

    _hideDropdown() {
        $('.unify-header-notification-drop').addClass('unify-hidden')
    }

    _handleDismissClick(i, event, id){
        var that = this;
        // stop the follow link click event
        event.stopPropagation();
        event.preventDefault();

        new Promise(function (resolve, reject) {
            let url = `${that.endpoints.NotificationUri}/dismiss`;
            $.ajax({
                context: this,
                method: 'POST',
                url: url,
                dataType: 'json',
                data: { id: id }
            })
            .then(function (response) {
                // when signalR sends notifications changed it will trigger new fetch
            })
            .catch(function (response) {
                console.log('notificationdropdown.js -> _handleDismisseClick, Error in ajax request, reason:', reason);
            })
        });
    }

    _handleOnLinkClick(li, event, url) {
        // stop the follow link click event
        event.stopPropagation();
        event.preventDefault();
        
        if (typeof url !== 'undefined') {
            window.location.href = url;
        }
    }

    _updateTopBarWithNrNotifications() {
        var nr = this.objects.length;

        var nrNotificationsInSvg = `
            <svg xmlns="http://www.w3.org/2000/svg" class="notifications" height="1em" width="1em" viewBox="0 0 200 200">
                <circle id="header-notification-circle" cx="100" cy="100" r="100" fill="red" />
                <text x="50%" y="50%" text-anchor="middle" font-size="140px" fill="#fff" stroke="#fff" stroke-width="2px" dy="0.36em">
                    ${nr}
                </text>
            </svg>`;

        if(nr === 0){
            // do not show nr notifications if no exist
            nrNotificationsInSvg = '';
        }

        if ($('#notification-drop .notifications').length > 0) {
            // already exist, remove that first
            $('#notification-drop .notifications').remove();
        }

        $('#notification-drop .unify-header-notifications-wrapper').prepend(nrNotificationsInSvg);
    }
}
